<template>
    <div class="app-body">
        <div class="a-flex-rsbc">
            <bread-crumb></bread-crumb>
            <div class="a-flex-rfsc">
                <el-button type="primary" plain size='small' @click="handleEdit">广告设置</el-button>
            </div>
        </div>
        <div class="businessInfo">
            <div class="business-baseinfo">
                <div class="a-flex-rfsc">
                    <span class="a-c-master a-fs-16 a-fw-700">{{ details.stationName || '-' }}</span>
                    <el-tag class="a-ml-10" :type="statusStyleDic[details.adAuthScope]">{{ details.adAuthScope | initDic(adAuthScopDic) }}</el-tag>
                </div>
                <div class="a-flex-rfsfs a-flex-wrap">
                    <div class="a-flex-rfsfs mt21 mr80">
                        <span class="title c79">区域</span>
                        <span class="content a-c-master">{{ details.provinceName || '' }}-{{ details.cityName || '' }}-{{ details.districtName || '' }}</span>
                    </div>
                    <div class="a-flex-rfsfs mt21 mr80">
                        <span class="title c79">项目</span>
                        <span class="content a-c-master">{{ details.incomeName || '-' }}</span>
                    </div>
                    <div class="a-flex-rfsfs mt21 mr80">
                        <span class="title c79">商户</span>
                        <span class="content a-c-master">{{ details.operateCompanyName || '-' }}</span>
                    </div>
                    <div class="a-flex-rfsfs mt21 mr80">
                        <span class="title c79">最后编辑人</span>
                        <span class="content a-c-master">{{ details.updateUserName || '-' }}-{{ details.updateUserPhone || '-' }}</span>
                    </div>
                    <div class="a-flex-rfsfs mt21 mr80">
                        <span class="title c79">最后编辑时间</span>
                        <span class="content a-c-master">{{ details.updateTime || '-' }}</span>
                    </div>
                </div>
            </div>
            <div class="tabs">
                <el-tabs v-model="tabAc" >
                    <el-tab-pane label="点位列表" name="dwlb">
                        <station-ad-list :tabledata="details.authList"></station-ad-list>
                    </el-tab-pane>
                    <el-tab-pane label="操作记录" name="czjl">
                        <station-ad-history :stationId="details.stationId" ref="adHistory"></station-ad-history>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <station-ad-setting ref="adSetting" @change='adSettingSuccess'></station-ad-setting>
    </div>
</template>

<script>
import util from '@/utils/util'
import stationAdHistory from './components/station-ad-history.vue';
import StationAdList from './components/station-ad-list.vue';
import StationAdSetting from './components/station-ad-setting.vue';
export default {
    components: { stationAdHistory, StationAdList, StationAdSetting },
    data() {
        return {
            util,
            id: '',
            tabAc: "dwlb",
            details: {},//详情信息
            statusStyleDic: {
                '0': 'danger',
                '1': 'warning',
                '2': 'success',
            },
            adAuthScopDic: [
                {
                    label: '全部开启',
                    value: '2'
                },
                {
                    label: '部分开启',
                    value: '1'
                },
                {
                    label: '全部关闭',
                    value: '0'
                }
            ],
        };
    },
    created () {
        this.id = this.$route.query.id
        if(this.id){
            this.getInfo()
        }
    },
    methods:{
        // 获取信息
        getInfo () {
            this.$Axios._get({
                url: this.$Config.apiUrl.stationAdDetails,
                params: {
                    id: this.id
                },
            })
            .then(({data})=>{
                this.details = {
                    ...data,
                }
            })
            .catch(err=>{

            })
        },
        handleEdit () {
            this.$refs['adSetting'].id = this.details.id
            this.$refs['adSetting'].stationId = this.details.stationId
            this.$refs['adSetting'].getInfo()
        },
        adSettingSuccess () {
            this.getInfo()
            this.$refs['adHistory'].handleRefresh()
        },
    },
}
</script>

<style lang="scss" scoped>
.business-baseinfo{
    border-radius: 3px;
    padding: 20px 20px 10px
}
.businessInfo{
    font-size: 14px;
    height: 100%;
    overflow-y: auto;
    background: #FFFFFF;
}
.mt64{
    margin-top: 64px
}
.mt21{
    margin-top: 21px
}
.mr80{
    margin-right: 60px;
}
.c79{
    color: #797979
}
.title{
    width: 120px;
    margin-right: 16px;
}
.content{
    width: 300px
}
.business-baseinfo-item{
    background: linear-gradient(90deg, #F5F7FA 0%, #FBFCFD 100%);
    border-radius: 3px;
    padding: 11px 17px;
    margin-top: 14px;
}
.a-fs-8{
    font-size: 8px
}
.c-pl-6{
    padding-left: 6px
}
.tabs{
    // background: #ffffff;
    // padding: 0 20px;
    // margin-top: 20px;
    // padding: 13px 17px 0
}
/deep/ .el-tabs__item {
    // color: #007aff;
    font-size: 14px;
}

/deep/ .el-tabs__item.is-active {
    color: #007AFF;
    font-weight: bold;
}

/deep/ .el-tabs__nav-wrap::after {
    background: none !important;
}

/deep/ .el-tabs__header {
    padding-left: 24px;
    // padding-top: 20px;
    margin-bottom: 2px;
    border-radius: 3px;
    background: #FFFFFF
}
.switchBusiness{
    background: #007AFF;
    border-radius: 3px;
    color: #ffffff;
    font-size: 10px !important
}

</style>